var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8453 22C44.5598 23.2376 44.5598 24.7624 43.8453 26L35.6547 40.1865C34.9402 41.4241 33.6197 42.1865 32.1906 42.1865L15.8094 42.1865C14.3803 42.1865 13.0598 41.4241 12.3453 40.1865L4.1547 26C3.44017 24.7624 3.44017 23.2376 4.1547 22L12.3453 7.81347C13.0598 6.57586 14.3803 5.81347 15.8094 5.81347L32.1906 5.81347C33.6197 5.81347 34.9402 6.57586 35.6547 7.81347L43.8453 22Z",
    fill: "#7637FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.9734C24.3785 22.3501 23.5358 22 22.6571 22C21.7784 22 20.9357 22.3501 20.3142 22.9734L17.9706 25.3241C17.3491 25.9476 17 26.7933 17 27.6751C17 28.5569 17.3491 29.4026 17.9706 30.0262C18.5921 30.6497 19.435 31 20.3139 31C21.1928 31 22.0357 30.6497 22.6571 30.0262L23.8286 28.8508",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25.0266C23.6215 25.6499 24.4642 26 25.3429 26C26.2216 26 27.0643 25.6499 27.6858 25.0266L30.0294 22.6759C30.6509 22.0524 31 21.2067 31 20.3249C31 19.4431 30.6509 18.5974 30.0294 17.9738C29.4079 17.3503 28.565 17 27.6861 17C26.8072 17 25.9643 17.3503 25.3429 17.9738L24.1714 19.1492",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f3b66180a0aec2db67fc1979c7305fcb.svg";
export { ForwardRef as ReactComponent };